/* external links new window */
var links = document.links;
if (links.length > 0) {
  for(var i = 0; i < links.length; i++) {
    if (links[i].hostname != window.location.hostname)
      links[i].target = '_blank'
  }
}

/* affix scroll */
window.onscroll = scroll;

const navlist = document.getElementById("navbar-main");
const sticky = navlist.offsetTop;

function scroll () {
  var scrollTop = window.pageYOffset;

  if( scrollTop > 100 ){
    navlist.classList.add("affix");
  }
  else
  {
    navlist.classList.remove("affix");
  }
}

/* embed iframe responisve */
var wrap = (query, tag) => {
  document.querySelectorAll( query ).forEach( elem => {
    const div = document.createElement(tag);
    elem.parentElement.insertBefore(div, elem);
    div.appendChild(elem);
    div.className = 'embed-container';
  });
};

wrap('iframe', 'div');